import React from 'react';
import { Container, Card, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const InstallInstructions = () => {
	const isInstalled = window.matchMedia('(display-mode: standalone)').matches ||
	                    window.navigator.standalone === true;

	return (
		<Container className='py-5'>
			<h1 className='mb-4' style={{ color: '#384971' }}>
				Install Portal App
			</h1>

			{isInstalled && (
				<Alert variant='success'>
					<i className='fa-sharp fa-solid fa-check-circle me-2'></i>
					Portal is already installed! You're all set.
				</Alert>
			)}

			<Card className='shadow-sm mb-4'>
				<Card.Body>
					<Card.Title>Why Install?</Card.Title>
					<ul>
						<li><strong>Quick Access:</strong> Launch from your home screen like a native app</li>
						<li><strong>Offline Support:</strong> Access cached content even without internet</li>
						<li><strong>Full Screen:</strong> No browser bars for a cleaner experience</li>
						<li><strong>Notifications:</strong> Get updates about lessons and payments (coming soon)</li>
					</ul>
				</Card.Body>
			</Card>

			<h3 className='mb-4'>Installation Instructions</h3>

			<Row className='g-4'>
				<Col md={6}>
					<Card className='h-100 shadow-sm'>
						<Card.Body>
							<div className='mb-3'>
								<i className='fa-brands fa-chrome fa-3x' style={{ color: '#4285F4' }}></i>
							</div>
							<Card.Title>Chrome / Edge (Desktop)</Card.Title>
							<ol className='small'>
								<li>Look for the install icon <i className='fa-sharp fa-solid fa-circle-plus'></i> in the address bar</li>
								<li>Click "Install" or "Add to Desktop"</li>
								<li>Confirm installation</li>
								<li>Portal will open in a new window</li>
								<li>Find the app icon on your desktop or in your applications</li>
							</ol>
							<Alert variant='info' className='small mb-0'>
								<strong>Tip:</strong> You can also go to Settings → Install Color Your Voice Portal
							</Alert>
						</Card.Body>
					</Card>
				</Col>

				<Col md={6}>
					<Card className='h-100 shadow-sm'>
						<Card.Body>
							<div className='mb-3'>
								<i className='fa-brands fa-safari fa-3x' style={{ color: '#006CFF' }}></i>
							</div>
							<Card.Title>Safari (Mac)</Card.Title>
							<ol className='small'>
								<li>Click the Share button <i className='fa-sharp fa-solid fa-arrow-up-from-square'></i> in the toolbar</li>
								<li>Select "Add to Dock"</li>
								<li>Name the app "CYV Portal"</li>
								<li>Click "Add"</li>
								<li>Find the icon in your Dock</li>
							</ol>
							<Alert variant='info' className='small mb-0'>
								<strong>Note:</strong> Requires Safari 16.4+ and macOS Ventura+
							</Alert>
						</Card.Body>
					</Card>
				</Col>

				<Col md={6}>
					<Card className='h-100 shadow-sm'>
						<Card.Body>
							<div className='mb-3'>
								<i className='fa-brands fa-android fa-3x' style={{ color: '#3DDC84' }}></i>
							</div>
							<Card.Title>Chrome (Android)</Card.Title>
							<ol className='small'>
								<li>Tap the menu icon ⋮ in the top right</li>
								<li>Tap "Install app" or "Add to Home screen"</li>
								<li>Tap "Install"</li>
								<li>Find the app icon on your home screen</li>
							</ol>
							<Alert variant='info' className='small mb-0'>
								<strong>Tip:</strong> You may see an install banner at the bottom of the screen
							</Alert>
						</Card.Body>
					</Card>
				</Col>

				<Col md={6}>
					<Card className='h-100 shadow-sm'>
						<Card.Body>
							<div className='mb-3'>
								<i className='fa-brands fa-apple fa-3x' style={{ color: '#000' }}></i>
							</div>
							<Card.Title>Safari (iOS)</Card.Title>
							<ol className='small'>
								<li>Tap the Share button <i className='fa-sharp fa-solid fa-arrow-up-from-square'></i> at the bottom</li>
								<li>Scroll down and tap "Add to Home Screen"</li>
								<li>Name it "CYV Portal"</li>
								<li>Tap "Add"</li>
								<li>Find the icon on your home screen</li>
							</ol>
							<Alert variant='info' className='small mb-0'>
								<strong>Note:</strong> Must use Safari browser on iOS
							</Alert>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			<Card className='shadow-sm mt-4'>
				<Card.Body>
					<Card.Title>Troubleshooting</Card.Title>
					<div className='small'>
						<p><strong>Don't see the install option?</strong></p>
						<ul>
							<li>Make sure you're using a supported browser (Chrome, Edge, Safari)</li>
							<li>Ensure you're not in Incognito/Private mode</li>
							<li>Try refreshing the page</li>
							<li>Clear browser cache and try again</li>
						</ul>

						<p><strong>Already installed but can't find it?</strong></p>
						<ul>
							<li><strong>Windows:</strong> Check Start Menu or Desktop</li>
							<li><strong>Mac:</strong> Check Applications folder or Dock</li>
							<li><strong>Mobile:</strong> Check all home screens</li>
						</ul>
					</div>
				</Card.Body>
			</Card>

			<div className='text-center mt-4'>
				<Link to='/portal/login' className='btn btn-primary'>
					← Back to Login
				</Link>
			</div>
		</Container>
	);
};

export default InstallInstructions;
